import { Skeleton } from "@mui/material";

interface StatChipSkeletonProps {
  width?: number;
}

function StatChipSkeleton({ width = 96 }: StatChipSkeletonProps) {
  return (
    <Skeleton
      variant="rounded"
      width={width}
      height={26}
      sx={{ borderRadius: "8px" }}
    />
  );
}

export default StatChipSkeleton;
